import React from 'react';
import Icon from '../../../components/AppIcon';

const EventFilters = ({ filters, onFilterChange, eventCount }) => {
  const eventTypeOptions = [
    { value: 'check-in', label: 'Check-Ins', icon: 'UserCheck', color: 'success' },
    { value: 'check-out', label: 'Check-Outs', icon: 'UserMinus', color: 'primary' },
    { value: 'payment', label: 'Payments', icon: 'DollarSign', color: 'success' },
    { value: 'payment-failed', label: 'Payment Failures', icon: 'CreditCard', color: 'error' },
    { value: 'class-booking', label: 'Class Bookings', icon: 'Calendar', color: 'primary' },
    { value: 'class-cancellation', label: 'Cancellations', icon: 'XCircle', color: 'error' },
    { value: 'equipment-alert', label: 'Equipment Alerts', icon: 'AlertTriangle', color: 'warning' },
    { value: 'staff-activity', label: 'Staff Activity', icon: 'Users', color: 'primary' },
    { value: 'capacity-alert', label: 'Capacity Alerts', icon: 'AlertCircle', color: 'warning' }
  ];

  const locationOptions = [
    { value: 'all', label: 'All Locations' },
    { value: 'Main Entrance', label: 'Main Entrance' },
    { value: 'Main Exit', label: 'Main Exit' },
    { value: 'Front Desk', label: 'Front Desk' }
  ];

  const handleEventTypeToggle = (eventType) => {
    const currentTypes = filters?.eventTypes || [];
    const newTypes = currentTypes?.includes(eventType)
      ? currentTypes?.filter(t => t !== eventType)
      : [...currentTypes, eventType];
    onFilterChange({ eventTypes: newTypes });
  };

  const handleSearchChange = (e) => {
    onFilterChange({ searchQuery: e?.target?.value });
  };

  const handleLocationChange = (e) => {
    onFilterChange({ location: e?.target?.value });
  };

  const handleClearFilters = () => {
    onFilterChange({
      eventTypes: [],
      searchQuery: '',
      location: 'all'
    });
  };

  const hasActiveFilters = 
    filters?.eventTypes?.length > 0 || 
    filters?.searchQuery || 
    filters?.location !== 'all';

  return (
    <div className="space-y-6">
      {/* Search */}
      <div className="card">
        <h3 className="text-sm font-semibold text-foreground mb-3">Search Events</h3>
        <div className="relative">
          <Icon 
            name="Search" 
            size={18} 
            className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" 
          />
          <input
            type="text"
            placeholder="Search by member, transaction..."
            value={filters?.searchQuery || ''}
            onChange={handleSearchChange}
            className="w-full pl-10 pr-4 py-2 rounded-lg border border-border bg-background text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring"
          />
        </div>
      </div>

      {/* Event Types */}
      <div className="card">
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-sm font-semibold text-foreground">Event Types</h3>
          {filters?.eventTypes?.length > 0 && (
            <span className="text-xs text-primary font-medium">
              {filters?.eventTypes?.length} selected
            </span>
          )}
        </div>
        <div className="space-y-2">
          {eventTypeOptions?.map((option) => {
            const isSelected = filters?.eventTypes?.includes(option?.value);
            return (
              <button
                key={option?.value}
                onClick={() => handleEventTypeToggle(option?.value)}
                className={`w-full flex items-center gap-3 px-3 py-2 rounded-lg transition-colors text-left ${
                  isSelected
                    ? 'bg-primary/10 text-primary border border-primary/20' :'bg-muted/30 text-foreground hover:bg-muted/50 border border-transparent'
                }`}
              >
                <Icon name={option?.icon} size={16} />
                <span className="text-sm flex-1">{option?.label}</span>
                {isSelected && <Icon name="Check" size={16} />}
              </button>
            );
          })}
        </div>
      </div>

      {/* Location Filter */}
      <div className="card">
        <h3 className="text-sm font-semibold text-foreground mb-3">Location</h3>
        <select
          value={filters?.location || 'all'}
          onChange={handleLocationChange}
          className="w-full px-3 py-2 rounded-lg border border-border bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-ring"
        >
          {locationOptions?.map((option) => (
            <option key={option?.value} value={option?.value}>
              {option?.label}
            </option>
          ))}
        </select>
      </div>

      {/* Results Summary */}
      <div className="card bg-primary/5 border-primary/20">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
            <Icon name="Filter" size={20} className="text-primary" />
          </div>
          <div>
            <p className="text-sm font-semibold text-foreground">{eventCount} Events</p>
            <p className="text-xs text-muted-foreground">Matching filters</p>
          </div>
        </div>
      </div>

      {/* Clear Filters */}
      {hasActiveFilters && (
        <button
          onClick={handleClearFilters}
          className="w-full px-4 py-2 rounded-lg bg-muted text-foreground hover:bg-muted/80 transition-colors focus-ring text-sm font-medium"
        >
          Clear All Filters
        </button>
      )}
    </div>
  );
};

export default EventFilters;